import React, {useEffect, useRef, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from 'react-bootstrap';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import Checkbox from '@mui/material/Checkbox';
import { IconButton } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import useAxiosProtect from '../../hooks/useAxiosProtect';

const HMartAlertsModal = props => {
    const floatRegex = /^(-?\d*\.?\d*)?$/;

    var init = useRef(true);
    const axiosProtect = useAxiosProtect();

    const [formFields, setFormFields] = useState({
        minPH: '',
        minPHErr: '',
        maxPH: '',
        maxPHErr: '',
        notifyOnce: false,
        globalErr: ''
    });

    const [tabValue, setTabValue] = useState('create');

    const [activeAlerts, setActiveAlerts] = useState([]);
    const [archivedAlerts, setArchivedAlerts] = useState([]);
    const [alertPendingArchival, setAlertPendingArchival] = useState(-1);
    const [alertPendingDeletion, setAlertPendingDeletion] = useState(-1);

    const {auth} = useAuth();

    useEffect(() => {
        if(!init.current) return;
        init.current = false;

        axiosProtect.get(`/hm/hmart/get-alerts?uid=${auth?.id}`).then(response => {
            console.log(response.data)
            let activeAlertsArray = response.data.alerts.filter(alert => !alert?.archived);
            let archivedAlertsArray = response.data.alerts.filter(alert => alert?.archived);

            setActiveAlerts(activeAlertsArray);
            setArchivedAlerts(archivedAlertsArray);
        }).catch(error => {
            console.log(error);
        });
    }, []);

    const handleTabChange = (e, v) => {
        setTabValue(v);
    }

    const validateAlertForm = () => {
        let isValid = true;
        let tempForm = {...formFields};

        if(tempForm.minPH === ''){
            tempForm.minPHErr = 'Required';
            isValid = false;
        }else if(parseFloat(tempForm.minPH) < 0 || parseFloat(tempForm.minPH) > 14){
            tempForm.minPHErr = 'Must be between 0 and 14';
            isValid = false;
        }else{
            tempForm.minPHErr = '';
        }

        if(tempForm.maxPH === ''){
            tempForm.maxPHErr = 'Required';
            isValid = false;
        }else if(parseFloat(tempForm.maxPH) < 0 || parseFloat(tempForm.maxPH) > 14){
            tempForm.maxPHErr = 'Must be between 0 and 14';
            isValid = false;
        }else{
            tempForm.maxPHErr = '';
        }

        if(tempForm.minPHErr === '' && tempForm.maxPHErr === ''){
            let minValue = parseFloat(tempForm.minPH);
            let maxValue = parseFloat(tempForm.maxPH);

            if(minValue >= maxValue){
                tempForm.globalErr = 'Minimum pH must be less than maximum';
                isValid = false;
            }else if(maxValue - minValue < 0.1){
                tempForm.globalErr = 'Valid range must be at least 0.1 difference';
                isValid = false;
            }else{
                tempForm.globalErr = '';
            }
        }else{
            tempForm.globalErr = '';
        }

        setFormFields(tempForm);

        return isValid;
    }

    const createNewAlert = () => {
        if(!validateAlertForm()) return;

        let payload = {
            uid: auth?.id,
            min_pH: parseFloat(formFields.minPH),
            max_pH: parseFloat(formFields.maxPH),
            notify_once: formFields.notifyOnce
        };

        axiosProtect.post('/hm/hmart/create-alert', payload).then(res => {
            let newAlertArray = [...activeAlerts];
            newAlertArray.unshift(res.data.createdAlert);

            setActiveAlerts(newAlertArray);

            setTabValue('alerts');

            setFormFields({
                minPH: '',
                minPHErr: '',
                maxPH: '',
                maxPHErr: '',
                notifyOnce: false,
                globalErr: ''
            });
        }).catch(err => {
            console.log(err);

            setFormFields(prev => ({
                ...prev,
                globalErr: err.response.data.error
            }));
        });
    }

    const archiveAlert = () => {
        let tempArch = [...archivedAlerts];
        let tempActive = [...activeAlerts];

        axiosProtect.put(`/hm/hmart/toggle-alert?alertID=${alertPendingArchival}`).then(response => {
            for(let i = 0;i<tempActive.length;++i){
                if(tempActive[i].id === alertPendingArchival){
                    tempActive.splice(i, 1);
                    break;
                }
            }

            let archivedAlert = response.data.toggledAlert;
            tempArch.unshift(archivedAlert);

            setArchivedAlerts(tempArch);
            setActiveAlerts(tempActive);
            setAlertPendingArchival(-1);
        }).catch(error => {
            console.log(error);
        });  
    }

    const reinstateAlert = alertID => {
        let tempArch = [...archivedAlerts];
        let tempActive = [...activeAlerts];

        axiosProtect.put(`/hm/hmart/toggle-alert?alertID=${alertID}`).then(response => {
            for(let i = 0;i<tempArch.length;++i){
                if(tempArch[i].id === alertID){
                    tempActive.push(tempArch[i]);
                    tempArch.splice(i, 1);
                    break;
                }
            }

            tempActive.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));

            setArchivedAlerts(tempArch);
            setActiveAlerts(tempActive);
        }).catch(error => {
            console.log(error);
        });  
    }

    const deleteAlert = () => {
        let tempArr = [];

        axiosProtect.delete(`/hm/hmart/delete-alert?alertID=${alertPendingDeletion}`).then(response => {
            for(let i = 0;i<archivedAlerts.length;++i){
                if(archivedAlerts[i].id === alertPendingDeletion) continue;
                tempArr.push(archivedAlerts[i]);
            }

            setArchivedAlerts(tempArr);
            setAlertPendingDeletion(-1);
        }).catch(error => {
            console.log(error);
        });        
    }

    return(
        <Modal
            show={props.alertsModalOpen}
            onHide={() => props.setAlertsModalOpen(false)}
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <Box sx={{width: '100%', backgroundColor:'rgba(255,255,255,0.4)'}}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'rgb(0,177,168)'
                            },
                            '& .MuiTab-textColorSecondary.Mui-selected': {
                                color: 'rgb(0,177,168)'
                            },
                            '& .MuiTab-textColorSecondary': {
                                color: 'rgb(8,114,182)'
                            },
                        }}
                        aria-label="secondary tabs example"
                    >
                        <Tab value="create" label="Create new alert" />
                        <Tab value="alerts" label="Alerts" />
                    </Tabs>
                </Box>
            </Modal.Header>

            <Modal.Body style={{maxHeight:'75vh', overflowY:'scroll'}}>
                {
                    tabValue === 'create' ? 
                    <div>
                        <div style={{width:'100%', textAlign:'center', marginBottom:'1%', visibility: formFields.globalErr === '' ? 'hidden' : 'visible'}}>
                            <small className="text-error">
                                {formFields.globalErr}
                            </small>
                        </div>
                        
                        <p>Notify <strong>{auth?.email}</strong> when pH falls out of the following range:</p>

                        <div style={{display:'flex', flexDirection:'row'}}>
                            <FormControl fullWidth style={{flex:'2'}}>
                                <OutlinedInput
                                    id="outlined-adornment-amount"
                                    placeholder='Minimum'
                                    value={formFields.minPH}
                                    error={formFields.minPHErr !== ''}
                                    onChange={e => {
                                        if(!floatRegex.test(e.target.value)) return;

                                        setFormFields(prev => ({
                                            ...prev,
                                            minPH: e.target.value
                                        }));
                                    }}
                                    inputProps={{
                                        autoComplete: 'off',
                                        autoCorrect: 'off',
                                        autoCapitalize: 'off',
                                        spellCheck: 'false',
                                        inputMode: 'decimal',
                                    }}
                                />
                                <small style={{visibility:`${formFields.minPHErr === '' ? 'hidden' : 'visible'}`, color:'red'}}>{formFields.minPHErr}</small>
                            </FormControl>

                            <div style={{flex:'1', textAlign:'center', lineHeight:'2.5'}}>
                                <p style={{margin:'0', marginTop:'3%'}}>and</p>
                            </div>

                            <FormControl fullWidth style={{flex:'2'}}>
                                <OutlinedInput
                                    id="outlined-adornment-amount"
                                    placeholder='Maximum'
                                    value={formFields.maxPH}
                                    error={formFields.maxPHErr !== ''}
                                    onChange={e => {
                                        if(!floatRegex.test(e.target.value)) return;

                                        setFormFields(prev => ({
                                            ...prev,
                                            maxPH: e.target.value
                                        }));
                                    }}
                                    inputProps={{
                                        autoComplete: 'off',
                                        autoCorrect: 'off',
                                        autoCapitalize: 'off',
                                        spellCheck: 'false',
                                        inputMode: 'decimal',
                                    }}
                                />
                                <small style={{visibility:`${formFields.maxPHErr === '' ? 'hidden' : 'visible'}`, color:'red'}}>{formFields.maxPHErr}</small>
                            </FormControl>
                        </div>

                        <br/>
                        
                        <FormControlLabel control={<Checkbox checked={formFields.notifyOnce} onChange={() => {
                            setFormFields(prev => ({
                                ...prev,
                                notifyOnce: !formFields.notifyOnce
                            }))
                        }}/>} label="Disable this alert once triggered" />

                        <br/>
                        <br/>
                        
                        <small>*Note: if this alert is recurring, notifications will be sent once every 24 hours regulate traffic</small>
                    </div>
                    :
                    <div>
                        <Table style={{width:'100%'}} colSpan={6}>
                            <TableBody>
                                <div>
                                <TableRow>{`Active Alerts (${activeAlerts.length})`}</TableRow>
                                {activeAlerts.map((alert, i) => (
                                    <>
                                    <TableRow>
                                        <TableCell style={{borderBottom:'none'}} sx={{width:'34vw'}}>
                                            <span>
                                                Notify me when pH is less than <strong className="text-brand">{(Math.round(alert?.min_ph * 10) / 10).toFixed(1)}</strong> or greater than <strong className="text-brand">{(Math.round(alert?.max_ph * 10) / 10).toFixed(1)}</strong> 
                                                {` (${alert?.notify_once ? 'one time' : 'recurring'})`}
                                            </span>
                                        </TableCell>
                                        <TableCell style={{borderBottom:'none'}} sx={{width:'20%'}}>
                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                <div style={{flex:'1'}}></div>
                                                
                                                <Tooltip title='Archive' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                                                    <IconButton onClick={() => {
                                                        setAlertPendingArchival(alert?.id);
                                                    }}>
                                                        <ArchiveIcon style={{color:'rgb(0,177,168)'}}/>
                                                    </IconButton>
                                                </Tooltip>

                                                <div style={{flex:'1'}}></div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    {alert?.id === alertPendingArchival && 
                                    <Zoom in={alert?.id === alertPendingArchival}>
                                        <TableRow>
                                            <TableCell colSpan={6} style={{height:'fit-content', backgroundColor:'rgb(0,177,168)', borderBottom:'none'}}>
                                                <div style={{display:'flex', flexDirection:'row'}}>
                                                    <Button style={{flex:'6', textAlign:'center', border:'none', backgroundColor:'rgba(0,0,0,0)', cursor:'default'}}>
                                                        <div >
                                                            <span>Archive this alert?</span>
                                                            <br/>
                                                            <small>The alert will not trigger while archived</small>
                                                        </div>
                                                    </Button>

                                                    <Button style={{flex:'2', backgroundColor:'white', border:'2px solid white'}} onClick={() => {
                                                        archiveAlert();
                                                    }}><span style={{color:'rgb(0,177,168)'}}>Archive</span></Button>

                                                    <div style={{flex:'0.5'}}></div>

                                                    <Button style={{flex:'2', border:'2px solid white', backgroundColor:'rgba(0,0,0,0)'}} onClick={() => {
                                                        setAlertPendingArchival(-1);
                                                    }}>Cancel</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </Zoom>
                                    }
                                    </>
                                ))}

                                <br/>

                                <TableRow>{`Archived Alerts (${archivedAlerts.length})`}</TableRow>
                                {archivedAlerts.map((alert, i) => (
                                    <>
                                    <TableRow>
                                        <TableCell style={{borderBottom:'none'}} sx={{width:'34vw'}}>
                                            <span>
                                                Notify me when pH is less than <strong className="text-brand">{(Math.round(alert?.min_ph * 10) / 10).toFixed(1)}</strong> or greater than <strong className="text-brand">{(Math.round(alert?.max_ph * 10) / 10).toFixed(1)}</strong> 
                                                {` (${alert?.notify_once ? 'one time' : 'recurring'})`}
                                            </span>
                                        </TableCell>
                                        <TableCell style={{borderBottom:'none'}} sx={{width:'20%'}}>
                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                <div style={{flex:'1'}}></div>

                                                <Tooltip title='Re-enable' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                                                    <IconButton onClick={() => {
                                                        reinstateAlert(alert?.id);
                                                    }}>
                                                        <UnarchiveIcon className="text-brand"/>
                                                    </IconButton>
                                                </Tooltip>

                                                <div style={{flex:'1'}}></div>

                                                <Tooltip title='Delete' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                                                    <IconButton onClick={() => {
                                                        setAlertPendingDeletion(alert?.id)
                                                    }}>
                                                        <DeleteForeverIcon style={{color:'rgb(220, 53, 69)'}}/>
                                                    </IconButton>
                                                </Tooltip>

                                                <div style={{flex:'1'}}></div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    {alert?.id === alertPendingDeletion && 
                                    <Zoom in={alert?.id === alertPendingDeletion}>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{height:'fit-content', backgroundColor:'red', borderBottom:'none'}}>
                                                <div style={{display:'flex', flexDirection:'row'}}>
                                                    <Button style={{flex:'6', textAlign:'center', border:'none', backgroundColor:'rgba(0,0,0,0)', cursor:'default'}}>Delete this alert?</Button>

                                                    <Button style={{flex:'2', backgroundColor:'white', border:'2px solid white'}} onClick={() => {
                                                        deleteAlert();
                                                    }}><span className="text-error">Delete</span></Button>

                                                    <div style={{flex:'0.5'}}></div>

                                                    <Button style={{flex:'2', border:'2px solid white', backgroundColor:'rgba(0,0,0,0)'}} onClick={() => {
                                                        setAlertPendingDeletion(-1);
                                                    }}>Cancel</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </Zoom>
                                    }
                                    </>
                                ))}
                                </div>
                            </TableBody>
                        </Table>
                    </div>
                }
            </Modal.Body>
            
            <Modal.Footer>
                <Button className="btn-brand-bg" style={{width:'fit-content', marginTop:'2%', border:'none'}} onClick={() => {
                    tabValue === 'create' ? createNewAlert() : props.setAlertsModalOpen(false);
                }}>{`${tabValue === 'create' ? 'Add alert' : 'Done'}`}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default HMartAlertsModal;